import * as React from "react";

import { PlpSelectedFacetOption } from "../model";

interface SelectedOptionProps {
  selectedOption: PlpSelectedFacetOption;
  action: (
    event: React.MouseEvent,
    selectedOption: PlpSelectedFacetOption
  ) => void;
}

export const SelectedOption: React.FunctionComponent<SelectedOptionProps> = (
  props
) => {
  const { selectedOption, action } = props;

  return (
    <button
      className="selected-option"
      onClick={action ? (event) => action(event, selectedOption) : undefined}
    >
      <p>{selectedOption.name || selectedOption.id}</p>
    </button>
  );
};
